import { writable } from 'svelte/store';
export function createShowAlertStore() {
    return writable({});
}
export const showAlert = createShowAlertStore();
